import type { ReactElement } from "react";
import {
	buttonClassNames,
	formClassNames,
} from "@/shared/constants/customStyleSets";

type Props = {
	onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
	message: string | ReactElement<unknown>;
	buttonText: string;
};
export const MessageForm: React.FC<Props> = ({
	onSubmit,
	message,
	buttonText,
}) => {
	return (
		<div data-testid="welcome-message-form" className={formClassNames}>
			<div className="flex-grow flex items-center justify-center mt-6">
				{message}
			</div>

			<div className="flex align-center justify-center mt-4 mb-4 ">
				<button
					type="button"
					className={buttonClassNames}
					onClick={onSubmit}
					data-testid="submit-button"
				>
					{buttonText}
				</button>
			</div>
		</div>
	);
};
